export const AW_ACCOUNT_MANAGEMENT_API_URL =
  process.env?.AWAPI_ACCOUNT_MANAGEMENT_API_URL || '/api/wealth/account-management';

export const AW_CIS_API_URL = process.env?.AW_CIS_API_URL || '/client-integration-svc';

export const AW_CIS_BETA_API_URL = process.env?.AW_CIS_BETA_API_URL || '/client-integration-svc-beta';

export const LOGIN_KEY = 'login';
